import { Box, useMediaQuery } from '@mui/material'
import styles from '@styles/leftSidebar.module.scss'
import { ListItem, ListItemButton, Divider } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import SideMenu from './sidebar/siderMenu'
import { styled, useTheme } from '@mui/material/styles'
import UserBox from './Userbox'
import { menuItems } from './sidebar/menuList'
import { GlobalContext } from '@providers/globalStore'
import { useContext } from 'react'

const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  borderRadius: '5px',
}))

const StyledListItem = styled(ListItem)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '60px',
  height: '60px',
  borderRadius: '5px',
  boxShadow: '0 3px 6px rgb(0 0 0 / 16%)',
}))

const UseLeftSideBar = (): [LeftSideBar: () => JSX.Element] => {
  const navigate = useNavigate()
  const { dispatch, hasRightByCatAndCode } = useContext(GlobalContext)

  const menu = [...menuItems]
  const LeftSideBar = () => {
    return (
      <Box className={styles.leftSidebar}>
        <SideMenu />
        <Divider sx={{ width: '50%', marginBottom: '10px' }} />
        <Box sx={{ overflow: 'auto', flex: 1 }}>
          {menu.map((item) =>
            item.children
              .filter(
                (child) =>
                  (child.category && hasRightByCatAndCode(child.category, ['C', 'R']) && child.hidden !== true) ?? true,
              )
              .map((child, childIndex) => (
                <Box key={`left-side-bar-item-${item.id}-${child.id}`}>
                  <StyledListItem sx={{ backgroundColor: child.colorCode }}>
                    <StyledListItemButton
                      onClick={() => {
                        navigate(child.url ?? '/')
                        dispatch({ type: 'toggleLeftDrawer', opened: false })
                      }}>
                      <Box
                        className={styles.sideBarIcon}
                        sx={{ backgroundColor: child.colorCode }}
                      />
                      <Box className={styles.text}>{child.acronym}</Box>
                    </StyledListItemButton>
                  </StyledListItem>
                  {item.children.length === childIndex + 1 ? (
                    <Divider sx={{ width: '100%', marginBottom: '10px' }} />
                  ) : (
                    <></>
                  )}
                </Box>
              )),
          )}
        </Box>
        <UserBox />
      </Box>
    )
  }
  return [LeftSideBar]
}

export default UseLeftSideBar
